exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gh-btn-read-more[data-v-4897deaf]{display:flex;justify-content:space-between;margin-top:1rem;margin-bottom:1rem}.gh-btn-view-all[data-v-4897deaf]{display:block;text-align:center}", ""]);

// exports
